import DynamicFormQuestion from './styled';

export default DynamicFormQuestion;
